module.exports = __webpack_public_path__ + "img/horse.2d4c7b1f.jpg";